import { GLOBAL_MAX_WIDTH } from "goi_common";
import { Box, Grid } from "@chakra-ui/react";
import { colors, getCdnImageSrc, Image, VStack } from "goi_common";
import { ReactNode } from "react";

interface ProductDetailCollaborationSectionProps {
  background?: string;
  top?: ReactNode;
}

export default function GlobalCollaborationSection({
  background = colors.gray50,
  top,
}: ProductDetailCollaborationSectionProps) {
  return (
    <VStack
      width="100%"
      alignItems="center"
      background={background}
      padding={"64px 24px 72px"}
    >
      <VStack maxWidth={`${GLOBAL_MAX_WIDTH}px`} width="100%" gap="40px">
        <Box className={"subtitle_21_b gray900"}>
          {top}
          {/* 고이는 KB핀테크, 서울지방변호사회 등<br />
          신뢰도 높은 회사 및 기관에게 <br />
          기업제휴 상조 서비스를 제공하고 있습니다. */}
        </Box>
        <VStack width="100%" alignItems="center">
          <Grid
            gridRowGap={"16px"}
            gridColumnGap={"4px"}
            gridTemplateColumns={"2fr 2fr 2fr"}
            width="100%"
          >
            <GridItem id={1} text="서울지방변호사회" />
            <GridItem id={2} text="약손명가" />
            <GridItem id={3} text="KB핀테크" />
            <GridItem id={4} text="TJ미디어" />
            <GridItem id={5} text="서울시농수산식품공사" />
            <GridItem id={6} text="HDC리조트" />
            <GridItem id={7} text="네파" />
            <GridItem id={8} text="카카오벤처스" />
            <GridItem id={9} text="서울대학교" />
          </Grid>
        </VStack>
      </VStack>
    </VStack>
  );
}

function GridItem({ id, text }: { id: number; text: string }) {
  return (
    <VStack alignItems="center" gap="8px" width="100%">
      <Box borderRadius={"100px"} overflow="hidden" width={"100px"}>
        <Image src={getCdnImageSrc(`direct/home/c-${id}.png`)} alt="" />
      </Box>
      <Box fontSize={14} fontWeight={500} className="gray700">
        {text}
      </Box>
    </VStack>
  );
}
